// TwoFactorCta.tsx — replaces a composer where a surface's two-factor write lock applies
// (1.27.70: the comment composer on the Videos pages). Same card as SignInCta.
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ConsolePanel } from '@/ui';

const Wrap = styled(ConsolePanel)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  flex-wrap: wrap;
`;

const Text = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

const EnableLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.font.body};
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.xs};
  padding: 6px 14px;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid transparent;
  text-decoration: none;
  background: ${({ theme }) => theme.color.cautionSoft};
  color: ${({ theme }) => theme.color.textPrimary};
`;

export function TwoFactorCta({ message }: { message: string }) {
  return (
    <Wrap role="status">
      <Text>{message}</Text>
      <EnableLink to="/settings/privacy">Turn on two-factor</EnableLink>
    </Wrap>
  );
}
